import { FC, Fragment } from 'react';
import { FormProvider } from 'react-hook-form';

import { DetailsForm } from 'src/features/details-form';
import { LoginDialog } from 'src/features/login-dialog';

import { EmailForm } from '../email-form';

import { LoggedInBanner } from './logged-in-banner';

import type { UserFormViewProps } from './types';

export const UserFormView: FC<UserFormViewProps> = ({
    methods,
    showDetailsForm,
    userExists,
    userLoggedIn,
    userHasBookings,
    onContinue,
    isEmailValid,
    onSubmit,
    hasRoommates,
    loading,
    isLoginDialogOpen,
    isUserExistsPending,
    toggleLoginDialog,
    currentEmail,
    building,
}) => {
    const { control } = methods;

    return (
        <FormProvider {...methods}>
            <Fragment>
                <LoggedInBanner />
                {!userLoggedIn && (
                    <EmailForm
                        control={control}
                        onContinue={onContinue}
                        showAdditionalFields={showDetailsForm && !userExists}
                        showCta={!showDetailsForm}
                        isEmailValid={isEmailValid}
                        isUserExistsPending={isUserExistsPending}
                    />
                )}

                {(showDetailsForm || userLoggedIn) && (
                    <DetailsForm
                        control={control}
                        onFormSubmit={onSubmit}
                        hasRoommates={hasRoommates}
                        loading={loading}
                        userHasBookings={userHasBookings}
                        userLoggedIn={userLoggedIn}
                        building={building}
                    />
                )}
                <LoginDialog
                    open={isLoginDialogOpen}
                    closeFn={toggleLoginDialog}
                    currentEmail={currentEmail}
                />
            </Fragment>
        </FormProvider>
    );
};
